import React from "react";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";

/** Renders today's appointments and offers a Check-in shortcut for expected ones. */
export default function AppointmentList({ rows, onCheckIn }) {
  if (rows.length === 0) {
    return <div className="text-sm text-[#4A5A50] py-8 text-center">No appointments today.</div>;
  }
  return (
    <ul className="divide-y divide-[#E4DFCF] bg-white rounded-xl border border-[#E4DFCF]">
      {rows.map((a) => (
        <li key={a.id} className="p-4 flex items-start justify-between gap-3">
          <div>
            <div className="font-medium">{a.visitor_name}</div>
            <div className="text-xs text-[#4A5A50]">
              {a.visitor_company || ""} · Host: {a.host_name} · {a.scheduled_at ? format(new Date(a.scheduled_at), "HH:mm") : ""}
            </div>
            {a.purpose && <div className="text-xs text-[#4A5A50] mt-0.5">{a.purpose}</div>}
          </div>
          {a.status === "expected" && (
            <Button
              size="sm"
              className="bg-[#0F5E39] hover:bg-[#083F22] text-white"
              onClick={() => onCheckIn(a)}
              data-testid={`appt-checkin-${a.id}`}
            >Check in</Button>
          )}
          {a.status === "checked_in" && (
            <span className="text-[10px] uppercase tracking-widest bg-[#E1F0E6] text-[#0F5E39] px-2 py-1 rounded-full">
              arrived
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
